if (!customElements.get('usp-grid')) {
  class UspGrid extends HTMLElement {
    constructor() {
      super();
      this.usps = this.querySelectorAll('.js-usp');

      if (this.usps.length < 1) return;

      this.initialLoad = true;
      this.interval = null;
      this.init();
    }

    init() {
      this.usps.forEach((usp) => {
        usp.addEventListener('click', () => {
          const target = usp.getAttribute('data-target');

          this.activateUsp(target);

          this.autoplay('pause');
        });
      });

      this.addEventListener('mouseenter', () => {
        this.autoplay('pause');
      });

      if (Shopify.designMode) {
        this.autoplay('play');
        this.autoplay('pause');
        this.initialLoad = false;

        document.addEventListener('shopify:block:select', (event) => {
          const blockIsUsp = event.target.classList.contains('js-usp');
          
          if (!blockIsUsp) return;

          const target = event.target.getAttribute('data-target');

          if (target) this.activateUsp(target);
        })
      } else {
        const observer = new IntersectionObserver(this.handleIntersection.bind(this), { root: null, rootMargin: '0px' });
        observer.observe(this);
      }
    }

    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.autoplay('play');
          this.initialLoad = false;
        } else {
          this.autoplay('stop');
        }
      });
    }

    autoplay(state) {    
      const limit = this.usps.length;
      let target = this.initialLoad ? this.dataset.uspActive : 1;
      
      if (state === 'play') {
        if (this.initialLoad) {
          this.activateUsp(target);
          target++;
        }

        this.interval = setInterval(() => {
          if (target > limit) target = 1;
          this.activateUsp(target);
          target++;
        }, 5000);
      } else if (state == 'pause') {
        clearInterval(this.interval);
      } else if (state === 'stop') {
        clearInterval(this.interval);
        this.pauseVideos();
      }
    }

    pauseVideos() {
      this.usps.forEach((usp) => {
        const video = usp.querySelector('.js-usp-video');
        if (video) video.pause();
      });
    }

    activateUsp(target) {
      if (!target) return;

      this.dataset.uspActive = target;
      this.pauseVideos();

      const inactiveUsps = this.querySelectorAll(`.usp-grid__item:not(.usp-grid__item--${target})`);

      inactiveUsps.forEach((usp) => {
        usp.classList.remove('usp-grid__item--active');
      });

      const activeUsp = this.querySelector(`.usp-grid__item--${target}`);

      if (!activeUsp) return;

      activeUsp.classList.add('usp-grid__item--active');
      const activeVideo = activeUsp.querySelector('.js-usp-video');
      
      if (activeVideo) {
        activeVideo.play();
      } 
    }
  }

  customElements.define('usp-grid', UspGrid);
}
